$ = jQuery;
function header() {
  $(document).ready(function () {

    // --- NEW: Search Popup Logic ---
    $('.header-search-trigger').on('click', function (e) {
      e.preventDefault();
      $('#search-modal').fadeIn(300);
      $('body').addClass('search-opened');
      $('.content-header').addClass('active');
      if ($('.custom-search-modal').length) {
        $('.custom-search-modal').css('top', $('.content-header').outerHeight() + 'px');
      }
    });

    $('.close-modal, .search-overlay-bg').on('click', function () {
      $('#search-modal').fadeOut(200);
      $('body').removeClass('search-opened');
      $('.content-header').removeClass('active');
    });
    // --- End Search Logic ---

    // Mobile toggle
    $('.navbar-toggler').on('click', function () {
      $('.collapse.navbar-collapse').toggleClass('show');
      $(this).toggleClass('opened');
      $('body').toggleClass('opened-navigation');
    });

    // mobile sub menu close icon
    $('.menu-close-icon').on('click', function() {
      $('.navbar-toggler.opened').trigger('click');
    })

    const desktopMenu = window.matchMedia('(min-width: 992px)');

    function initDesktopHoverMenu(e) {
      $('.content-header .menu--main ul li .menu-item--expanded.dropdown-toggle').off('mouseenter mouseleave');
      $('.dropdown-menu.sub-menu').off('mouseenter mouseleave');

      if (e.matches) {
        // DESKTOP hover
        $('.content-header .menu--main ul li .menu-item--expanded.dropdown-toggle')
        .on('mouseenter', function () {
          $(this).siblings('.dropdown-menu').addClass('show');
        })
        .on('mouseleave', function () {
          $(this).siblings('.dropdown-menu').removeClass('show');
        });

        $('.dropdown-menu.sub-menu')
        .on('mouseenter', function () {
          $(this).addClass('show');
        })
        .on('mouseleave', function () {
          $(this).removeClass('show');
        });
      }
    }

    // first load
    initDesktopHoverMenu(desktopMenu);

    // on resize screen
    desktopMenu.addEventListener('change', initDesktopHoverMenu);

    $('.submenu-toggler').click(function() {
      $(this).siblings('.sub-menu').toggleClass('show');
    });

    $('.sub-menu-title').click(function() {
      $(this).parents('.dropdown-menu').toggleClass('show');
    })

    $(window).resize(function() {
      paddingTop();
    })

    $('.mega-menu')
    .on('mouseenter', function () {
      $(this).siblings('.main-nav__link').addClass('hovered');
    })
    .on('mouseleave', function () {
      $(this).siblings('.main-nav__link').removeClass('hovered');
    });

    $('.main-nav__item.has-mega-menu')
    .on('mouseenter', function () {
      $(this).parents('.content-header').addClass('active');
    })
    .on('mouseleave', function () {
      $(this).parents('.content-header').removeClass('active');
    });
  });
}

window.onscroll = function() {
  stickyHeader();
};

window.onload = function() {
  paddingTop();
  stickyHeader();
}

let lastScrollTop = 0;

function stickyHeader() {
  const currentScroll = window.scrollY;
  const header = $('.content-header');

  if (currentScroll > 2) {
    header.addClass('sticky');
  } else {
    header.removeClass('sticky');
    header.removeClass('scroll-up');
  }

  if (currentScroll < lastScrollTop && currentScroll > 2) {
    header.addClass('scroll-up');
  } else {
    header.removeClass('scroll-up');
  }

  lastScrollTop = currentScroll;
}

function paddingTop() {
  if ($('.padding-height-padding').length) {
    $('.padding-height-padding').css('padding-top', $('.content-header').outerHeight() + 'px');
  }
}
